import { CompanyAPI } from '@api';

const checkDriversAvaliabilityNew = (groupId) => CompanyAPI.checkDriversAvaliabilityNew(
  { group_id: groupId },
)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { checkDriversAvaliabilityNew };
